import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { Avatar } from '@pickleballinc/ui/components/ui/avatar';
import clsx from 'clsx';

import { publicEnv } from '@/lib/env';
import { RankingPlayerBadgeInfo } from '@/modules/results/types';

interface MatchPlayerAvatarProps {
  name: string;
  img: string;
  proLevelId: string | number | true | RankingPlayerBadgeInfo;
  isWinner: boolean;
  isSingles: boolean;
}

export const MatchPlayerAvatar = ({
  name,
  img,
  proLevelId,
  isWinner,
  isSingles,
}: MatchPlayerAvatarProps) => (
  <Avatar
    name={name}
    src={img ? getCDNURL(img, 200, 200, 0, proLevelId === 4 || proLevelId === 0) : undefined}
    defaultSrc={getCDNURL(
      `${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/legacy/profile-image.svg`,
      200,
      200
    )}
    variant='transparent'
    className={clsx(
      'size-full bg-experiment/50',
      isWinner ? 'border-4 border-green-400' : 'border border-white'
    )}
    textClassName={clsx('text-white', isSingles ? 'text-4xl sm:text-7xl' : 'text-xl sm:text-4xl')}
  />
);
